import React, { useState } from 'react';
import './Opponents.scss';
import Card from '../../../ui-components/card/Card';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { battleCreationActions, battleCreationSelector } from '../../../redux/slices/battleCreation';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as ChevronRight } from '../../../ui-components/icon/svgs/chevronRight.svg';
import { appDataSelector } from '../../../redux/slices/appDataSlice';
import { ContestantType } from '../../../types/ContestantType';
import Button from '../../../ui-components/button/Button';
import { userSelector } from '../../../redux/slices/userSlice';


const Opponents = () => {

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { previousOpponents } = useAppSelector(appDataSelector);
  const battle = useAppSelector(battleCreationSelector);
  const user = useAppSelector(userSelector);

  const [selectedOpponents, setSelectedOpponents] = useState<ContestantType[]>([]);

  const onOpponentClick = (opponent: ContestantType) => {
    if (battle.isGroupBattle) {
      if (!selectedOpponents.includes(opponent) && selectedOpponents.length < 3) {
        setSelectedOpponents([...selectedOpponents, opponent]);
      } else if (selectedOpponents.includes(opponent)) {
        setSelectedOpponents(selectedOpponents.filter(e => e.id !== opponent.id));
      }
    } else {
      dispatch(battleCreationActions.addOpponent(opponent));
      navigate('/start-new-battle/start-new-battle-with');
    }
  }

  return (
    <>
      <Card
        backUrl="/start-new-battle"
        variant="MENU"
        title="Start New Battle"
      >
        <div className="opponents">
          {battle.isGroupBattle ? <p style={{ opacity: .7 }}>Select up to 3 opponents</p> : <p style={{ opacity: .7 }}>Choose Opponent</p>}

          {previousOpponents.length > 0 && (
            <div className="opponents__opponents-list">
              {previousOpponents.map((opponent) => {
                return (
                  <div
                    key={opponent.id}
                    className="opponents__opponents-list__opponent"
                    style={selectedOpponents.includes(opponent) ? { color: 'var(--success)', fontWeight: "bold" } : {}}
                    onClick={() => onOpponentClick(opponent)}
                  >
                    {opponent.username}
                    <ChevronRight />
                  </div>
                )
              })}

              {selectedOpponents.length > 1 && (
                <Button
                  style={{ float: "right" }}
                  onClick={() => {
                    dispatch(battleCreationActions.setContestants([{ id: user.id, username: user.username }, ...selectedOpponents]));
                    navigate("/start-new-battle/start-new-battle-with")
                  }}
                >
                  Continue
                </Button>
              )}
            </div>
          )}

          {previousOpponents.length < 1 && <p>No opponents found.</p>}
        </div>
      </Card>
    </>
  )
}

export default Opponents;